var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{directives:[{name:"ripple",rawName:"v-ripple",value:({ class: "secondary--text" }),expression:"{ class: `secondary--text` }"}],staticClass:"mx-auto py-1",class:{
    'my-5': _vm.$vuetify.breakpoint.smAndDown,
    'my-7': _vm.$vuetify.breakpoint.mdAndUp
  },attrs:{"to":_vm.to}},[_c('v-list-item',[_c('v-list-item-content',[_c('v-list-item-title',{staticClass:"text-h5 black--text",class:{
          'text-h5': _vm.$vuetify.breakpoint.smAndDown
        }},[_vm._v(" "+_vm._s(_vm.title)+" ")])],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }